var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories"},_vm._l((_vm.categories),function(category){return _c('div',{staticClass:"category-container"},[(category.display)?_c('Category',{attrs:{"category":category}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }